import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from '../../i18n/useTranslation.js';
import { FreePrice, Price } from './SalesPrice.styled.js';
export const PriceFormatter = ({ size, variant, price, withEuroSign = false, isFormerPrice = false, withoutStrikethrough = false, }) => {
    const { t } = useTranslation('salesPriceCurrent');
    let FormattedPrice = _jsx(_Fragment, {});
    if (price === 0 && variant === 'regular') {
        FormattedPrice = _jsx(FreePrice, { children: t('free') });
    }
    else if (price) {
        const isRoundPrice = Number.isInteger(price);
        const formattedPrice = new Intl.NumberFormat('nl-NL', {
            minimumFractionDigits: isRoundPrice ? 0 : 2,
            maximumFractionDigits: 2,
        }).format(price);
        FormattedPrice = (_jsxs(Price, { isFormerPrice: isFormerPrice, size: size, withoutStrikethrough: withoutStrikethrough, children: [withEuroSign ? '€ ' : '', formattedPrice, isRoundPrice && _jsx(_Fragment, { children: ",-" })] }));
    }
    return FormattedPrice;
};
//# sourceMappingURL=PriceFormatter.js.map